import React from 'react'
import { CircularProgress } from '@material-ui/core'

export type MessageLoaderProps = {
  children?: React.ReactNode
}

export const MessageLoader: React.FC<MessageLoaderProps> = (props: MessageLoaderProps) => {
  return (
    <div className={`max-w-screen flex flex-col items-center bg-white rounded-xl p-2 sm:p-4 mx-2 gap-y-5 box-border`}>
      <CircularProgress color="primary" />
      {props.children}
    </div>
  )
}
